import React from 'react';
import { Badge as BootstrapBadge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { branch, compose, mapProps, renderNothing, withProps } from 'recompose';
import { Icon } from '../../components';

const NotificationBadge = branch(
  ({ notification }) => !notification,
  renderNothing
)(({ notification }) => (
  <BootstrapBadge bsClass='icon-notification'>
    {notification}
  </BootstrapBadge>
));

const MobileNavMenuItem = ({
  MenuItemContainer,
  label,
  icon,
  iconProps,
  notification,
  upperBadge,
  ...props
}) => (
    <li>
      <MenuItemContainer {...props}>
        <Icon {...{ ...iconProps, icon }}>
          {
            upperBadge ?
              null :
              <NotificationBadge {...{ notification }} />
          }
        </Icon>
        <span>{label}</span>
      </MenuItemContainer>
      {
        upperBadge ?
          <NotificationBadge {...{ notification }} /> :
          null
      }
    </li>
  );

const isMailTo = (route) => route && route.indexOf('mailto:') === 0

export default compose(
  withProps(({ externalLink, route }) => ({
    MenuItemContainer: route && !externalLink ? Link : 'a'
  })),
  mapProps(({ externalLink, onClick, route, ...props }) => ({
    ...props,
    to: route ? route : null,
    href: route ?
      externalLink ?
        route :
        null :
      '#',
    onClick: onClick ?
      (e) => {
        e.preventDefault();
        onClick();
      } :
      null,
    target: externalLink ?
      isMailTo(route) ?
        undefined :
        '_blank' :
      undefined
  }))
)(MobileNavMenuItem);



// WEBPACK FOOTER //
// ./src/containers/partials/nav/mobile-nav-menu-item.js